export const CART_REQUEST = "CART_REQUEST";
export const CART_SUCCESS = "CART_SUCCESS";
export const CART_ERROR = "CART_ERROR";
export const CART_ADD = "CART_ADD";
export const CART_UPDATE = "CART_UPDATE";
export const CART_VALIDATE = "CART_VALIDATE";
export const CART_MODE = "CART_MODE";
export const CART_DELETE = "CART_DELETE";
export const CART_PURCHASE = "CART_PURCHASE";
export const CART_RENDER = "CART_RENDER";
export const CART_PURCHASE_PENDING = "CART_PURCHASE_PENDING";
export const CART_PURCHASE_SUCCESS = "CART_PURCHASE_SUCCESS";
export const CART_PURCHASE_FAILURE = "CART_PURCHASE_FAILURE";
export const CART_RESTAPI = "CART_RESTAPI";



// WEBPACK FOOTER //
// ./src/store/actions/cart.js